import { useState, useEffect } from "react"
import Filters from "components/Warehouse/Filters"
import "../assets/css/warehouse.css"
import 'assets/scss/warehouse.scss';

import Dashboard from "components/Warehouse/dashboard/Dashboard"

import { useDispatch, useSelector } from "react-redux"
import toast, { Toaster } from "react-hot-toast"

import { WarehouseTraffic } from "components/Warehouse/WarehouseTraffic";
import { updateWarehouseData } from "redux/warehouse/warehouseSlice";
import { changeDisplay } from "redux/warehouse/warehouseSlice";
import { changeWarehouse } from "redux/warehouse/warehouseSlice";
import PartialCreator from "components/Warehouse/modals/PartialCreation";
import LoadingAnimation from "components/UI/Loader";
import { getWarehouseStatus } from "redux/warehouse/warehouseSlice";
import { Spinner } from "react-bootstrap";

const Warehouse = () => {
  const dispatch = useDispatch()
  const display = useSelector((state) => state.warehouse.display)
  const warehouse = useSelector((state) => state.warehouse.warehouse)
  const warehouseStatus = useSelector((state) => state.warehouse.warehouseStatus)
  const { loading } = useSelector((state) => state.warehouse)
  const filters = useSelector((state) => state.warehouse.filters)
  const { sort } = useSelector((state) => state.warehouse)
  const showPartialCreationModal = useSelector((state) => state.warehouse.modalStates.showPartialCreationModal)

  useEffect(() => {
    dispatch(getWarehouseStatus())
  }, [warehouse])

  useEffect(() => {
    if (display === "Outgoing") {
      dispatch({
        type: "warehouse/setFilters",
        payload: { "searchText": "", "orderType": "dock" },
      })
    }
    else {
      dispatch({
        type: "warehouse/setFilters",
        payload: { "searchText": "", "orderType": "all" },
      })
    }
  }, [display])

  useEffect(() => {
    dispatch(updateWarehouseData())
  }, [filters, warehouse, sort])

  const warehouses = ["Laredo", "Clarksville", "Taylor"];
  const displayOptions = ["Dashboard", "Incoming", "Outgoing"]

  return (
    <>
      <div className="row warehouse-main-section-buttons-wrapper">
        <div className="col">
          {warehouses.map((location) => (
            <button
              key={location}
              onClick={() => dispatch(changeWarehouse(location))}
              className={`warehouse-main-header ${warehouse === location ? "warehouse-active" : ""}`}
            >
              {location}
            </button>
          ))}
          <i className='fa fa-chevron-right'></i>
          <button
            key={"dashboard"}
            onClick={() => dispatch(changeDisplay("Dashboard"))}
            className={`warehouse-main-header ${display === "Dashboard" ? "warehouse-active" : ""}`}
          >
            Dashboard
          </button>
          <button
            key={'incoming'}
            onClick={() => dispatch(changeDisplay("Incoming"))}
            className={`warehouse-main-header ${display === "Incoming" ? "warehouse-active" : ""}`}
          >
            Incoming
            <span
              className="badge counter-badge"
            >
              {
                Number.isInteger(warehouseStatus.incoming_orders_count) 
                ? <>{warehouseStatus.incoming_orders_count}</>
                : <Spinner animation="border" size="sm" />
              }
            </span>
          </button>
          <button
            key={'outgoing'}
            onClick={() => dispatch(changeDisplay("Outgoing"))}
            className={`warehouse-main-header ${display === "Outgoing" ? "warehouse-active" : ""}`}
          >
            Outgoing
            <span
              className="badge counter-badge"
            >
              {
                Number.isInteger(warehouseStatus.outgoing_orders_count) 
                ? <>{warehouseStatus.outgoing_orders_count}</>
                : <Spinner animation="border" size="sm" />
              }
            </span>
          </button>
        </div>
      </div>
      {display !== "Dashboard" && <Filters />}
      <div
        style={{
          opacity: (loading && !showPartialCreationModal) ? 1 : 0,
          transition: "opacity 0.5s ease-out",
          position: "fixed",
          justifyContent: "center",
          zIndex: loading ? 1000 : -1,
          top: "40%",
          left: "50%",
        }}
      >
        <div className="d-flex justify-content-center align-items-center">
          <LoadingAnimation />
        </div>
      </div>
      <div
        style={{
          backfaceVisibility: loading ? "hidden" : "visible",
          opacity: loading ? 0.8 : 1,
          transition: "opacity 0.5s ease-in-out",
          pointerEvents: loading ? "none" : "auto",
        }}
      >
        <>
          {display === "Dashboard" ?
            <Dashboard />
            :
            <>
              <WarehouseTraffic />
            </>
          }
        </>
      </div>
      <PartialCreator />
      <Toaster position='bottom-right' />
    </>
  )
}

export default Warehouse
